import React from "react";
import { Slider, Box, Typography } from "@mui/material";

const DieselTankSlider = ({ value, onChange, label }) => {
    // Mapeo entre valores numéricos y cadenas de texto
    const valueToLabelMap = {
        0: "EMPTY",
        1: "1/16",
        2: "1/8",
        3: "3/16",
        4: "1/4",
        5: "5/16",
        6: "3/8",
        7: "7/16",
        8: "1/2",
        9: "9/16",
        10: "5/8",
        11: "11/16",
        12: "3/4",
        13: "13/16",
        14: "7/8",
        15: "15/16",
        16: "FULL",
    };

    // Convertir el valor numérico al texto correspondiente
    const marks = Object.keys(valueToLabelMap).map((key) => ({
        value: Number(key),
        label: valueToLabelMap[key],
    }));

    const numericValue = Object.keys(valueToLabelMap).find(
        (key) => valueToLabelMap[key] === value
    );

    return (
        <Box sx={{ width: '100%', maxWidth: 600, margin: "0 auto", textAlign: "center" }}>
            <Typography variant="h6" gutterBottom>
                {label}
            </Typography>
            <Slider
                value={numericValue ? Number(numericValue) : 0}
                onChange={(event, newValue) => onChange(newValue)} // Prop para manejar el cambio
                step={1} // Incremento por cada tick del slider
                marks={marks} // Usa los valores y etiquetas mapeados
                min={0}
                max={16}
                valueLabelDisplay="on"
                valueLabelFormat={(val) => valueToLabelMap[val]} // Muestra el texto correspondiente en el tooltip
                sx={{
                    marginBottom: 3,
                    '& .MuiSlider-markLabel': {
                        fontSize: '0.75rem', // Ajusta el tamaño de fuente de las etiquetas
                        whiteSpace: 'nowrap', // Evita que las etiquetas se corten
                        transform: 'translateX(-50%)', // Centra las etiquetas correctamente
                    },
                    '& .MuiSlider-root': {
                        padding: '20px 0', // Asegura espacio suficiente alrededor del slider
                    },
                }}
            />
        </Box>
    );
};

export default DieselTankSlider;